
<div class="mb-1">
    <v-row class="no-frame">
        <v-col class="no-frame mr-1 lm-border pa-3 col-8">
            <v-row class="no-frame" v-for="(role,index) in roles" :key="index">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        v-model = "filter.role[role.id]"
                        :label  = "role.name"
                        class   = "mt-0 role-label"
                        :ripple = "false"
                        @change = "onChanged"
                        hide-details
                    />
                    <c-tag
                        class="mt-2"
                        :label="role.label"
                    />
                </v-col>
            </v-row>
        </v-col>
        <v-col class="no-frame lm-border pa-3 ml-1 ">
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "aktiv"
                        v-model = "filter.active"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChanged"
                        hide-details
                    />
                </v-col>
            </v-row>
            <!--
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   ="umfirmiert"
                        v-model = "filter.renaming"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChanged"
                        hide-details
                    />
                </v-col>
            </v-row>
            -->
            <v-row class="no-frame">
                <v-col class="no-frame v-flex">
                    <v-checkbox
                        label   = "inaktiv"
                        v-model = "filter.inactive"
                        class   = "mt-0"
                        :ripple = "false"
                        @change = "onChanged"
                        hide-details
                    />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
    <v-row class="no-frame">
        <v-col class="no-frame mt-2 lm-border pa-3">
            <c-customer-select
                label   = "Kunde"
                v-model = "filter.customer"
                hide-details
                class="pb-2"
                @change="onCustomerChanged"
            />
        </v-col>
    </v-row>

</div>
